module.exports = __webpack_public_path__ + "img/presentation.78aacd8c.svg";